// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1054":"2e0925e3","1441":"47b66bf5"}[chunkId] + ".chunk.css";
};